import { LeftOutlined } from "@ant-design/icons"
import React from "react"
import styled from "styled-components"
import { Descripition } from "../../../utils"
import { useRouter } from "next/router"
import { FloatButton } from "antd"
import { AosWrapper } from "../../molecules/AosWrapper"

const { BackTop } = FloatButton

const Background = styled.div`
  background: ${(props) => props.theme.blackBackgroundGradient};
`

const Wrapper = styled.div`
  max-width: 1500px;
  margin: auto;
  padding: 100px;
  color: ${(props) => props.theme.base};
  @media (max-width: 786px) {
    padding: 60px 30px;
  }
  .ant-float-btn-circle {
    height: 52px;
    border-radius: 100%;
    width: 52px;
  }
`
const GoBackWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  gap: 22px;
  div {
    ${(props) => props.theme.typography.cardTitle4}
  }
`

const ImgWrapper = styled.div`
  margin-top: 30px;
  img {
    border-radius: 25px;
    object-fit: cover;
    @media (max-width: 768px) {
      height: 280px;
    }
  }
`
const Content = styled.div`
  margin: auto;
  width: 862px;
  @media (max-width: 1085px) {
    width: 100%;
  }
`
const Title = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  ${(props) => props.theme.typography.sectionHeadline};
  white-space: break-spaces;
  @media (max-width: 1085px) {
    white-space: normal;
  }
  @media (max-width: 567px) {
    font-size: 1.375rem;
  }
`
const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`
const Date = styled.div`
  ${(props) => props.theme.typography.navMobItemFont};
  padding-left: 11px;
  color: ${(props) => props.theme.textDisabled};
`
const Descripitions = styled(Descripition)`
  margin-top: 20px;
  text-align: justify;
  margin-bottom: 0;
  color: ${(props) => props.theme.whiteIcon};
  @media (max-width: 567px) {
    white-space: break-spaces;
  }
`

const NewsDetailSection: React.FC = () => {
  const router = useRouter()
  return (
    <Background>
      <BackTop icon={<img src="/assets/icons/up-symbol.svg" />} />
      <AosWrapper animatePreScroll={true}>
        <Wrapper>
          <GoBackWrapper onClick={() => router.push("/rtw-blogs")}>
            <LeftOutlined />
            <div>{"Go Back"}</div>
          </GoBackWrapper>
          <ImgWrapper>
            <img
              src="/assets/imgs/news-cover.png"
              width={"100%"}
              height={542}
            />
          </ImgWrapper>
          <Content>
            <AosWrapper animatePreScroll={true}>
              <Title>
                {"Entertaining Uses of Chat GPT You Never\nKnew Were Possible"}
              </Title>
              <DateWrapper>
                <img src="/assets/icons/date.svg" width={15} height={15} />
                <Date>{"2023/04/24"}</Date>
              </DateWrapper>
              <Descripitions>
                {
                  "Lorem ipsum dolor sit amet consectetur. Vel quis ac phasellus mauris odio in. Consequat massa tempor varius nisi metus laoreet. Tortor mollis aliquam ac eu nisl viverra. Augue vitae mauris eu nibh et odio nam. Maecenas arcu non eget mauris metus id nisl amet. Pulvinar ultrices sit scelerisque et. Euismod neque sit magnis vitae ipsum venenatis pulvinar quam sed. Justo justo vulputate pellentesque mauris eget auctor luctus orci fusce. Lacus diam faucibus dis lorem elit odio et nec nullam. Ipsum in quis morbi orci non amet mattis. Nibh rutrum faucibus fringilla arcu praesent non vitae. Turpis metus ut lectus at mus.\n\nSollicitudin netus tortor duis dolor. Tempus id dolor aenean ultrices in mauris elementum. Consectetur nulla convallis iaculis fusce vestibulum nisl. Sed vehicula facilisis porta pretium velit gravida suspendisse. Et mi feugiat nec neque metus metus sodales. Enim quis eget vel dui eu varius aliquam vitae ultrices. Mattis molestie vitae elementum netus fusce sagittis sed. Cursus maecenas amet blandit molestie mauris libero sagittis semper.\n\nEst sit sociis risus tellus etiam eget molestie eu. Egestas odio egestas auctor semper. Id at leo ultricies nibh a faucibus. Elementum eleifend sed pellentesque lorem tempor metus. Arcu pulvinar ultricies scelerisque posuere nunc varius ornare. Amet nulla ut velit adipiscing phasellus enim pellentesque. Diam purus mi orci leo.\n\nAt quis mattis interdum curabitur quam enim. Ultricies auctor congue convallis mattis at viverra amet dapibus volutpat. Nam egestas sit dui nunc posuere sit. Arcu ullamcorper urna ut in neque tempus nunc fermentum. Venenatis tempus vitae non nunc sed in praesent nunc mauris. Duis nisl iaculis enim tincidunt. Massa nibh scelerisque purus imperdiet ut. Pellentesque viverra egestas magnis cras magna morbi elit. Tortor a non sed imperdiet vel nibh proin platea. Pharetra vitae rutrum tristique id enim ac lectus proin. Adipiscing sem consequat feugiat feugiat praesent donec ac aenean. Eu molestie et risus donec. In ut dictum vel nunc tincidunt pellentesque. Tellus scelerisque posuere neque eu euismod eu aliquam."
                }
              </Descripitions>
            </AosWrapper>
          </Content>
        </Wrapper>
      </AosWrapper>
    </Background>
  )
}

export { NewsDetailSection }
